import React, { useEffect, useMemo, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import styles from './IdentityExist.module.scss'
import AccountForm from '../../types/account-form.types'
import { State } from '../../state-actions-reducers'
import { searchByInn } from '../../hooks/useSearchByInnHook'
import { Lang } from '../../types/common-types'
import { getCommonContent, Services_Common_Dto_DT_Public_PublicOrganizationDto, Services_Common_Enums_SocialLinkType } from '../../hooks/useGetContactsCustomHook';
import TgIcon from '../../images/telegram.svg'
import WhatsAppIcon from '../../images/whatsapp.svg'
import PhoneIcon from '../../images/phone.svg'

interface Props {
  accountForm: AccountForm
  lang: Lang
  show: boolean
}

function InnExist({
  accountForm,
  lang,
  show
}: Props) {
  const { watch, setValue } = useFormContext<State>()
  const state = watch()

  function handleServerError() {
    setValue('serverError', true, { shouldDirty: true });
    alert(accountForm.serverError[lang]);
  }

  const onInnChange = async () => {
    const inn = state.F_FiscalType ? state.F_INN.replace(/\D/g, '') : state.taxIdentifier.replace(/\D/g, '');
    try {
      const response = await searchByInn(state, inn, state.F_FiscalType, state.citizenship)
      if (response.message !== 'Invalid token') {
        setValue('serverError', false, { shouldDirty: true });
        setValue('isIdentityOk', response.isInnOk, { shouldDirty: true });
      } else {
        handleServerError()
      }
    } catch (error) {
      handleServerError()
      console.error('Error in onIdentityChange:', error);
    }
  }

  useEffect(() => {
    if (state.F_INN.length >= 10 || state.taxIdentifier.length >= 10) {
      onInnChange()
    } else {
      setValue('isIdentityOk', true, { shouldDirty: true })
    }
  }, [state.F_INN, state.taxIdentifier]);

  const [contacts, setContacts] = useState<Services_Common_Dto_DT_Public_PublicOrganizationDto>()

  async function fetchContacts() {
    const response = await getCommonContent()
    setContacts(response)
  }

  useEffect(() => {
    fetchContacts();
  }, [])

  const phoneLink = useMemo(() => {
    return contacts?.phoneNumberPrimary
  }, [contacts])

  const tgLink = useMemo(() => {
    return contacts?.socialLinks?.find((e) => e.type === Services_Common_Enums_SocialLinkType.Telegram)
  }, [contacts])

  const whatsAppLink = useMemo(() => {
    return contacts?.socialLinks?.find((e) => e.type === Services_Common_Enums_SocialLinkType.Whatsapp)
  }, [contacts])

  return (
    show ? <div className="col-12">
      <div className={styles.identityExistContainer}>
        <b>{accountForm.identityExistHead[lang]}</b>
        <p>{accountForm.identityExistDesc[lang]}</p>
        <div className={styles.links}>
          {phoneLink && <a href={`tel:${phoneLink}`}>
            <img src={PhoneIcon} alt={'phone'}></img>
            {accountForm.phoneCallback[lang]}
          </a>}
          {tgLink?.link && <a href={tgLink?.link} target="_blank">
            <img src={TgIcon} alt={'tg'}></img>
            {accountForm.tgCallback[lang]}
          </a>}
          {whatsAppLink?.link && <a href={whatsAppLink?.link} target="_blank">
            <img src={WhatsAppIcon} alt={'whatsapp'}></img>
            {accountForm.whatsAppCallback[lang]}
          </a>}
        </div>
      </div>
    </div> : null
  )
}

export default InnExist
